import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import sna from "./Sna.jpg"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import sn1 from "./images/26ai1.png";
import sn2 from "./images/26ai2.png";
import sn3 from "./images/26ai3.png";
import sn4 from "./images/26ai4.png";
import sn5 from "./images/26ai5.png";


export default function SnaAccordion() {
  return (
    <div className="Accordian">
        <Accordion className="Accordian" style={{ backgroundColor: "white" }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography>
              <h3>Sensing and Automation</h3>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
  
              <div
                id="sna-challenge"
                style={{ backgroundColor: "white", color: "black" }}
              >
                <div className="challenge-content">
                  <h1
                    className="black text-center"
                    style={{ color: "#f49221" }}
                  >
                    Sensing And Automation
                  </h1>
                  <br />
                  
                  <h2 className="">
                    <strong>Hardware Recruitment Challenge 1</strong>
                  </h2>
                  
                  <h3>
                    <u>
                      {" "}
                      
                    </u>
                    
                  </h3>
                  <>
  <p>
    During operation, an autonomous ground vehicle (AGV) may encounter
    situations where continued motion could damage the vehicle or its
    surroundings. In such cases, pressing the <strong>Emergency Stop (E-Stop)</strong>{" "}
    must immediately bring the vehicle to a safe state. However, simply
    disconnecting the battery is not sufficient. While the motors must stop
    instantly, certain electronics may need to remain powered briefly,
    sensitive signals must remain reliable in an electrically noisy
    environment, and faults in one subsystem should not propagate to another.
  </p>

  <p>
    The power distribution and protection circuitry must therefore be designed
    around how each subsystem is expected to behave during both normal
    operation and an emergency shutdown.
  </p>

  <p>
    An autonomous ground vehicle (AGV) uses a <strong>24 V Embedded Control
    Board</strong> to power and control its onboard electronics. The board
    consists of:
  </p>

  <ul>
    <li>A DC motor driver</li>
    <li>A 5 V buck converter supplying an MCU and an onboard sensor</li>
    <li>An Emergency Stop (E-Stop) switch that disconnects the battery during fault conditions</li>
  </ul>

  <p>
    The schematic provided represents the initial implementation of the control
    board. Modify the design such that it satisfies the following
    requirements.
  </p>

  <h3>Requirements & Specifications</h3>

  <ol type="A">
    <li>
      <strong>DC Motors:</strong> When the E-Stop button is pressed, the
      motors must stop immediately.
    </li>

    <li>
      <strong>MCU:</strong> The MCU must remain operational (operating voltage:
      4–5 V) for <strong>50 ms</strong> after the E-Stop is activated.
    </li>

    <li>
      <strong>Sensor:</strong> The sensor must be immune to switching noise
      generated by the motor. Use only passive components to optimize signal
      integrity.
    </li>

    <li>
      <strong>Power Distribution:</strong> Protect the system against common
      electrical faults and isolate the power rails to prevent unintended
      current flow between subsystems.
    </li>

    <li>
      <strong>Motor Switching Device:</strong> Assume the DC motor is driven
      using an H-bridge comprising external N-channel MOSFETs. Select a
      commercially available MOSFET suitable for this application and justify
      your choice based on:
      <ul>
        <li>Drain-Source Voltage (VDS)</li>
        <li>Continuous Drain Current (ID)</li>
        <li>On-State Resistance (RDS(on))</li>
      </ul>
    </li>
  </ol>

  <p>
    <strong>Note:</strong> All loads are represented by equivalent resistive
    loads (boxed in the schematic). Do not alter their values. Where required,
    determine the load current from the given supply voltage and equivalent
    resistance. Assume steady-state operation wherever necessary.
  </p>

  <h3>Deliverables</h3>

  <ol>
    <li>Parts A &amp; B: LTspice/Falstad simulation.</li>
    <li>Parts C &amp; D: Hand-drawn or electronically drawn schematic.</li>
    <li>
      Part E: Selected MOSFET datasheet with a brief justification. Show all
      calculations and clearly state any assumptions made.
    </li>
  </ol>
  <div
  style={{
    display: "flex",
    justifyContent: "center",
    marginTop: "30px",
  }}
>
  <img
    src={sn1}
    alt="Hardware Challenge Schematic"
    style={{
      width: "80%",
      maxWidth: "700px",
      height: "auto",
      borderRadius: "10px",
    }}
  />
</div>

<h2>
  <strong>Hardware Recruitment Challenge 2</strong>
</h2>

<p>
  Kavya was testing the autonomous rover when everything seemed to be working
  perfectly, until the flight controller suddenly started receiving incorrect
  sensor data. After some debugging, she discovered that one of the analog
  sensors had gone faulty.
</p>

<p>
  There were three other sensors onboard that could provide the required
  measurement, but there was one problem: the flight controller had only a
  single ADC input available. Replacing the faulty sensor manually every time
  wasn't exactly an option.
</p>

<p>
  The sensors could fail, recover, or briefly produce an invalid reading while
  the rover was operating. More than one sensor could also be healthy at the
  same time, and allowing two sensor outputs to become electrically connected
  could corrupt the measurement altogether.
</p>

<p>
  Kavya decided that the flight controller shouldn't have to worry about any of
  this. A hardware circuit placed before the ADC should determine which sensor
  can be trusted, decide which one gets priority, and ensure that only the
  appropriate analog signal reaches the controller.
</p>

<p>
  Design a <strong>hardware-based sensor arbitration and signal-routing
  circuit</strong> satisfying the following requirements.
</p>

<h3>Sensor Details</h3>

<ol>
  <li>All four sensors operate from a <strong>5 V</strong> supply.</li>
  <li>S1 normally outputs <strong>0.4 V – 2.8 V</strong>.</li>
  <li>S2 normally outputs <strong>1.0 V – 4.0 V</strong>.</li>
  <li>S3 normally outputs <strong>0.8 V – 3.5 V</strong>.</li>
  <li>S4 normally outputs <strong>1.5 V – 4.5 V</strong>.</li>
</ol>

<h3>Requirements & Specifications</h3>

<ol>
  <li>
    The rover should normally depend on <strong>S1</strong>. If S1 cannot be
    used, it should automatically switch to <strong>S2</strong>, followed by
    <strong> S3</strong>, and finally <strong>S4</strong>.
  </li>

  <li>
    A sensor producing an incorrect value for a very short duration should
    <strong> not </strong>immediately be considered faulty. The signal must
    remain outside its specified operating range for at least
    <strong> 100 μs</strong> before the circuit takes any action.
  </li>

  <li>
    Once a sensor is declared unavailable, the ADC must receive data from the
    next valid sensor within <strong>50 μs</strong>.
  </li>

  <li>
    Switching between sensors must never create a direct electrical connection
    between any two sensor outputs, even momentarily.
  </li>

  <li>
    If a previously faulty sensor starts operating normally again, the circuit
    must determine whether control should return to it according to the original
    priority order.
  </li>

  <li>
    All decision-making and signal routing must be implemented entirely in
    <strong> hardware</strong>, without relying on the flight controller.
  </li>
</ol>

<h3>Available Components</h3>

<p>
  N-channel and P-channel MOSFETs, BJTs, diodes and Zener diodes, comparators,
  general-purpose op-amps, resistors, capacitors, inductors, basic logic gates,
  LEDs, optocouplers, relays, transformers, voltage regulators, switches, and
  passive filters.
</p>
<h3>Deliverables</h3>

  <ol>
    All submissions should be in the form of ltspice/falstad stimulation files.
  </ol>
<div
  style={{
    display: "flex",
    justifyContent: "center",
    marginTop: "30px",
  }}
>
</div>

</>
                  <h2>
  <strong>Embedded Recruitment Challenge 1</strong>
</h2>

<p>
  <strong>Adit's Dementia on a Dot Matrix</strong>
</p>

<p>
  Adit is an embedded enthusiast, but he's finally on vacation. He plans to
  venture into a foggy and dark cave, carrying nothing but a torch to guide his
  way.
</p>

<p>
  Your task is to build a <strong>pixel-based simulation</strong> of Adit's
  journey using an <strong>8×8 LED dot matrix</strong>. The cave is represented
  using an 8×8 bitmap where each bit denotes either a wall or an open path.
  Since the cave is completely dark, Adit can only see the walls within a
  <strong>5×5 visibility window</strong> centered around his current position.
</p>

<p>
  Player movement must be controlled using only
  <strong> two push buttons</strong>. One button cycles through the four
  cardinal directions, while the second button moves the player one pixel in
  the currently selected direction.
</p>

<h3>Maze Bitmap</h3>

<pre
  style={{
    background: "#111",
    color: "#fff",
    padding: "15px",
    borderRadius: "8px",
    overflowX: "auto",
  }}
>
{`00000000
10101011
10100000
11111110
00000000
11111101
00000001
01111111`}
</pre>

<p>
  The maze reference image and an example of the 5×5 visibility window (when
  the player is at <strong>(0,7)</strong>) can be found here:
</p>

<p>
  <a
    href="https://drive.google.com/drive/folders/1EtfVnPJQZjcYpcH-UeJ8eVRhrgR51Er7?usp=drive_link"
    target="_blank"
    rel="noreferrer"
  >
    Maze Reference Images
  </a>
</p>

<p>
  Submit a working simulation using an <strong>Arduino UNO R3</strong> in the
  following simulator:
</p>

<p>
  <a
    href="https://wokwi.com/"
    target="_blank"
    rel="noreferrer"
  >
    Wokwi Arduino Simulator
  </a>
</p>

<h3>Components</h3>

<ol>
  <li>A MAX7219 8×8 LED Dot Matrix Module.</li>

  <li>
    Two push buttons and four LEDs.
    <ul>
      <li>
        <strong>Button 1:</strong> Select the movement direction.
      </li>
      <li>
        <strong>Button 2:</strong> Move the player one pixel in the selected
        direction.
      </li>
      <li>
        Four LEDs should indicate the currently selected direction (North,
        South, East, West).
      </li>
    </ul>
  </li>
</ol>

<h3>Game Rules</h3>

<ol>
  <li>
    The player is controlled only through the push-button and LED interface.
    The player must <strong>never pass through walls.</strong>
  </li>

  <li>
    At any instant, only the walls inside a
    <strong> 5×5 visibility window</strong> surrounding the player should be
    displayed. This window must update continuously as the player moves.
  </li>

  <li>
    The maze indexing uses
    <strong> (0,0)</strong> for the top-left corner and
    <strong> (7,7)</strong> for the bottom-right corner. You may orient the
    physical LED matrix however you prefer, provided the displayed maze matches
    the supplied bitmap.
  </li>
</ol>

<h3>Player Visibility & Game Over Conditions</h3>

<ol>
  <li>
    The player must remain visible at all times and should blink continuously
    at a fixed interval (for example, every
    <strong> 150 ms</strong>).
  </li>

  <li>
    The player spawns at
    <strong> (0,7)</strong>. The game ends once the player reaches
    <strong> (0,0)</strong>.
  </li>

  <li>
    Upon game completion:
    <ul>
      <li>All direction LEDs must turn OFF.</li>
      <li>Push buttons must no longer accept any input.</li>
      <li>
        A custom <strong>Game Over animation</strong> of your choice should be
        displayed.
      </li>
    </ul>
  </li>
</ol>

<h3>Bonus Challenge – Dementia Feature</h3>

<ol>
  <li>
    Implement a feature allowing the player to remember previously explored
    paths for a limited duration of your choice (for example,
    <strong> 5 seconds</strong>).
  </li>

  <li>
    Previously revealed walls should remain visible during this memory period
    even after the player moves away, and should gradually disappear once the
    chosen time limit expires.
  </li>
</ol>

<h3>Submission Requirements</h3>

<ol>
  <li>Implement the solution in <strong>C/C++</strong>.</li>

  <li>
    Provide a link to the completed
    <strong> Wokwi simulation</strong>.
  </li>

  <li>
    Include a short explanation describing:
    <ul>
      <li>Player movement logic.</li>
      <li>Wall visibility implementation.</li>
    </ul>
  </li>

  <li>
    The code should be
    <strong> clean, modular, well-commented, and easy to understand.</strong>
  </li>
</ol>

<div
  style={{
    display: "flex",
    justifyContent: "center",
    marginTop: "30px",
  }}
>
  
</div>

<h2>
  <strong>Embedded Recruitment Challenge 2</strong>
</h2>

<p>
  <strong>Yash's Flying Cow Problem</strong>
</p>

<p>
  Yash lives the Texan dream , endless pasture, cattle grazing, big sky energy.
  Unfortunately "big sky" occasionally includes a tornado casually
  redecorating the farm, and Yash has personally witnessed a cow briefly become
  an astronaut before gravity reminded it otherwise. <strong>RIP Bessie.</strong>
  This project exists so the rest of the herd doesn't join her.
</p>

<p>
  Create a circuit using any simulation software of your choice. The circuit
  should consist of:
</p>

<h3>Required Components</h3>

<ol>
  <li>Any sensor capable of detecting tornadoes or high-speed wind.</li>
  <li>An Arduino.</li>
  <li>A single 7-segment display.</li>
  <li>A buzzer.</li>
  <li>Pushbuttons.</li>
  <li>Basic electronic components.</li>
</ol>

<h3>System Requirements</h3>

<p>
  The 7-segment display should display the severity of the wind using
  categories or numbers from <strong>1 to 3</strong>. Any wind speed exceeding
  <strong> Category 3</strong> should be displayed as
  <strong> S-O-S</strong> on the single 7-segment display, and the buzzer
  should beep <strong>SOS in Morse code</strong>.
</p>

<p>
  The circuit must also include a <strong>calibration mode</strong> for the
  sensor values.
</p>

<p>
  <strong>
    You are NOT allowed to use Arduino libraries for the 7-segment display or
    buzzer.
  </strong>{" "}
  You must create your own custom functions to control them.
</p>

<h3>Calibration Mode</h3>

<p>
  The calibration process should work as follows:
</p>

<ol>
  <li>
    The sensor should first be set to its
    <strong> minimum value</strong>. After pressing the confirmation button,
    this value should be recorded, and the 7-segment display should show
    <strong> 1</strong>.
  </li>

  <li>
    Next, the sensor should be set to its
    <strong> maximum value</strong>. After pressing the confirmation button,
    this value should be recorded, and the 7-segment display should show
    <strong> 2</strong>.
  </li>

  <li>
    Finally, the calibration button should be pressed again. A message stating
    <strong> "Calibration is complete"</strong> should be printed, and the
    7-segment display should show <strong>3</strong>.
  </li>
</ol>

<p>
  One pushbutton should be used to initialize the calibration mode, while
  another pushbutton should be used to confirm the minimum and maximum sensor
  values obtained during the calibration process.
</p>

<h3>Noise Filtering</h3>

<p>
  Since the sensor may produce faulty readings in a windy environment, a
  <strong> digital low-pass filter</strong> should be used to remove noise and
  unwanted fluctuations from the sensor readings. You must also provide
  comments in the code to explain its operation.
</p>

<h3>Report</h3>

<p>
  Create a report on this project.
</p>

<p>
  The report should include:
</p>

<ol>
  <li>The complete Arduino code.</li>
  <li>A list of components used.</li>
  <li>An explanation of why you selected the particular sensor.</li>
  <li>An explanation of why you selected the specific digital low-pass filter.</li>
  <li>An explanation of how the circuit works.</li>
</ol>

<p>
  The report should be created using
  <strong> Microsoft Word or Google Docs</strong> and may follow any format.
  The report should not exceed <strong>5 pages</strong>.
</p>

                    <h2>
  <strong>Automation Recruitment Challenge 1</strong>
</h2>

<h3>
  <strong>Rohan's Kitty Pity</strong>
</h3>

<p>
  One afternoon, Rohan was taking what he'd later call
  <strong> "a very important nap."</strong> Then the balcony door blew open,
  and his cat <strong>"Che"</strong> looked at the sky with teary eyes and
  declared, <em>"Liberty..."</em>
</p>

<p>
  Rohan sprinted after Che across the street and finally cornered her behind a
  bush. She sat there staring at him as if to say,
  <em> "Okay genius, what now?"</em>
</p>

<p>
  Wearing a tie for absolutely no reason, Rohan looped it around Che and
  dragged her home while she protested loudly enough to sound like she was
  being arrested live on television.
</p>

<p>
  Both survived. His dignity did not.
</p>

<p>
  That night, Rohan had an idea.
</p>

<p>
  <em>
    "Why am I sprinting into danger in my pyjamas? Next time, a robot does the
    chasing. Another one stands outside, safe, judging silently, and never
    losing signal."
  </em>
</p>

<h3>The Goal</h3>

<p>
  Your task is to design a <strong>pathfinding algorithm</strong> that controls
  <strong> two autonomous rovers</strong> moving simultaneously on a
  <strong> 20 × 20 grid</strong>.
</p>

<ul>
  <li>
    <strong>Lead Explorer (L)</strong>
    <ul>
      <li>Enters the sensitive inner area to collect data targets (<strong>*</strong>).</li>
      <li>Starts at <strong>(2, 1)</strong>.</li>
    </ul>
  </li>

  <li>
    <strong>Relay Escort (R)</strong>
    <ul>
      <li>Remains inside the outer buffer zone.</li>
      <li>
        Must maintain continuous communication with the Lead Explorer to relay
        collected data in real time.
      </li>
      <li>Starts at <strong>(1, 1)</strong>.</li>
    </ul>
  </li>
</ul>

<h3>The Map</h3>

<p>
  <strong>Note:</strong> To test your solution locally, you may write a simple
  visualization script that prints the grid and updates both rover positions
  after every move.
</p>

<ul>
  <li>
    <strong>0 (.) — Buffer Zone</strong>
    <br />
    The outer 3-cell-wide safe perimeter where the Relay Escort must remain.
  </li>

  <li>
    <strong>2 (,) — Sensitive Zone</strong>
    <br />
    The inner operating region where the Lead Explorer performs exploration.
  </li>

  <li>
    <strong>1 (#) — Wall</strong>
    <br />
    Impassable obstacles. Neither rover may move through them, and radio
    communication cannot pass through them.
  </li>
</ul>

<h3>Rules & Constraints</h3>

<ol>
  <li>
    <strong>Zone Restrictions</strong>
    <ul>
      <li>
        The Relay Escort (<strong>R</strong>) must never leave the Buffer Zone.
      </li>
      <li>
        The Lead Explorer (<strong>L</strong>) may travel anywhere except
        through walls.
      </li>
      <li>Neither rover may move outside the map boundaries.</li>
    </ul>
  </li>

  <li>
    <strong>Movement</strong>
    <ul>
      <li>
        Both rovers move <strong>exactly one step per turn</strong> in one of
        the four cardinal directions (Up, Down, Left, Right), or remain
        stationary.
      </li>
      <li>
        Diagonal movement is not permitted.
      </li>
      <li>
        Both rovers execute their moves
        <strong> simultaneously</strong>.
      </li>
    </ul>
  </li>

  <li>
    <strong>Tether Constraint</strong>
    <ul>
      <li>
        The straight-line (Euclidean) distance between the two rovers must
        <strong> never exceed 8.0 units</strong>.
      </li>
    </ul>
  </li>

  <li>
    <strong>Line of Sight</strong>
    <ul>
      <li>
        A continuous, unobstructed line of sight between the two rovers must be
        maintained at all times.
      </li>
      <li>
        If any wall blocks the direct communication path, the signal is lost
        and the mission immediately fails.
      </li>
    </ul>
  </li>
</ol>

<h3>Submission Requirements</h3>

<ol>
  <li>Implement your solution in <strong>Python</strong> or <strong>C++</strong>.</li>

  <li>
    Write a solver function that accepts:
    <ul>
      <li>The current map.</li>
      <li>The Lead Explorer's position.</li>
      <li>The Relay Escort's position.</li>
      <li>The remaining target locations.</li>
    </ul>
  </li>

  <li>
    The function should compute and return the
    <strong> next (x, y) move</strong> for both rovers.
  </li>

  <li>
    <strong>Partial solutions are welcome.</strong> Even if your implementation
    is incomplete, we strongly encourage you to submit your approach.
  </li>
</ol>

<div
  style={{
    display: "flex",
    justifyContent: "center",
    marginTop: "30px",
  }}
>
  <img
    src={sn2}
    alt="Automation Challenge 1"
    style={{
      width: "80%",
      maxWidth: "700px",
      height: "auto",
      borderRadius: "10px",
    }}
  />
</div>

<h2>
  <strong>Automation Recruitment Challenge 2</strong>
</h2>

<h3>
  <strong>Umang's Driving Exam</strong>
</h3>

<p>
  Umang recently took a driving exam. Through sources which nobody at Project
  MANAS can verify, we got to know that the examiner described his driving as
  <em> "creative."</em> Apparently, Umang treated lane markers as mere
  suggestions, executing differential-drive maneuvers in a standard hatchback.
</p>

<p>
  The examiner politely suggested that his unique talents were simply too grand
  for city streets and much better suited for robotics.
</p>

<p>
  Taking this as a compliment, Umang built an autonomous terrain rover named
  <strong> Magnus</strong>. Unfortunately, Magnus inherited the same
  spontaneous navigation logic.
</p>

<p>
  Your task is to override Magnus' navigation system and safely recover an
  umbrella that Umang may or may not have permanently "borrowed" from his
  roommate.
</p>

<h3>The Challenge – Quest for the Umbrella</h3>

<h3>The Mission</h3>

<p>
  Calculate a path that takes the rover from its starting position to the
  legendary umbrella in the
  <strong> minimum possible number of steps</strong>, while ensuring the rover
  neither runs out of battery nor overheats its engine.
</p>

<h3>The Terrain</h3>

<p>
  The rover operates on a
  <strong> 24 × 24 terrain grid</strong> consisting of mountains and valleys.
  It may only move in the four cardinal directions:
</p>


<ul>
  <li>Up</li>
  <li>Down</li>
  <li>Left</li>
  <li>Right</li>
</ul>

<div
  style={{
    display: "flex",
    justifyContent: "center",
    margin: "25px 0",
  }}
>
  <img
    src={sn3}
    alt="24x24 Terrain Grid"
    style={{
      width: "80%",
      maxWidth: "700px",
      height: "auto",
      borderRadius: "10px",
    }}
  />
</div>

<h3>System Constraints</h3>

<h4>Engine Heat</h4>

<ul>
  <li>The rover begins with <strong>0 heat</strong>.</li>
  <li>The maximum allowable heat is <strong>90</strong>.</li>
  <li>
    If the heat exceeds this value at any point, the engine melts and the
    mission immediately fails.
  </li>
</ul>
<div
  style={{
    display: "flex",
    justifyContent: "center",
    margin: "25px 0",
  }}
>
  <img
    src={sn4}
    alt="Engine Heat Illustration"
    style={{
      width: "65%",
      maxWidth: "500px",
      height: "auto",
      borderRadius: "10px",
    }}
  />
</div>

<h4>Battery</h4>

<ul>
  <li>The rover starts with exactly <strong>35 battery units</strong>.</li>
  <li>
    If the battery drops below zero before reaching the destination, the rover
    shuts down.
  </li>
  <li>
    Assume the rover initially faces the direction of its
    <strong> first movement</strong>, so the first step incurs
    <strong> no turning penalty.</strong>
  </li>
</ul>

<div
  style={{
    display: "flex",
    justifyContent: "center",
    margin: "25px 0",
  }}
>
  <img
    src={sn5}
    alt="Battery Constraints"
    style={{
      width: "65%",
      maxWidth: "500px",
      height: "auto",
      borderRadius: "10px",
    }}
  />
</div>

<h4>Power Stations</h4>

<p>
  Hidden across the terrain are
  <strong> two power stations.</strong>
</p>

<ul>
  <li>
    Landing on a station instantly restores the battery to the maximum value of
    <strong> 35</strong>.
  </li>
  <li>Each station may only be used once.</li>
</ul>

<h3>Your Objective</h3>

<p>
  Determine and return the
  <strong> minimum number of steps</strong> required to safely reach the
  umbrella.
</p>

<p>
  If reaching the target is mathematically impossible, return
  <strong> -1</strong>.
</p>

<h3>Input Specification</h3>

<p>
  Your solution should use the following constants:
</p>

<pre
  style={{
    background: "#111",
    color: "#fff",
    padding: "15px",
    borderRadius: "8px",
    overflowX: "auto",
  }}
>
{`START = (1, 1)
TARGET = (22, 22)
STATIONS = {(6, 19), (16, 4)}

MAX_HEAT = 90
MAX_BATTERY = 35`}
</pre>

<p>
  The complete <strong>24 × 24 terrain grid</strong> provided in the problem
  statement should be used as the input map for your implementation.
</p>
<h3>Terrain Grid</h3>

<p>
  Use the following <strong>24 × 24 terrain grid</strong> as the input map for
  your implementation.
</p>

<pre
  style={{
    background: "#111",
    color: "#fff",
    padding: "15px",
    borderRadius: "8px",
    overflowX: "auto",
    fontSize: "13px",
    lineHeight: "1.5",
  }}
>
{`[
    [2,1,1,1,3,5,5,5,5,5,5,3,2,2,3,5,5,5,5,5,4,2,0,0],
    [3,0,2,2,4,5,6,5,4,5,4,3,2,2,3,4,4,4,5,5,5,3,2,2],
    [5,5,4,4,5,6,5,4,3,4,4,3,2,2,3,3,3,3,4,5,5,4,4,4],
    [6,7,6,5,5,5,4,3,3,3,4,3,3,3,9,3,3,2,3,9,9,5,5,6],
    [6,7,6,5,5,4,3,2,2,3,4,5,5,9,9,9,3,2,9,3,2,5,5,6],
    [5,6,5,5,4,3,2,2,2,4,5,6,9,9,9,9,4,9,9,2,9,9,5,5],
    [4,4,4,4,3,3,3,3,3,4,5,9,9,9,9,5,4,9,3,0,3,9,4,4],
    [3,3,4,4,4,4,4,5,5,4,9,9,9,9,4,4,9,9,5,4,4,9,9,4],
    [3,3,4,5,5,5,6,7,6,4,3,9,2,9,9,2,4,9,9,9,9,9,5,4],
    [2,2,4,5,5,6,6,7,7,5,3,2,9,9,9,9,5,7,7,6,6,6,5,4],
    [2,2,3,4,4,5,6,7,7,5,4,3,4,9,9,9,9,7,7,5,5,5,4,3],
    [2,2,3,3,3,3,4,6,6,6,5,6,6,6,9,9,9,9,6,4,4,4,4,3],
    [3,3,4,4,3,3,3,4,5,6,6,7,8,8,7,9,9,5,4,3,3,4,4,4],
    [4,5,5,9,9,9,3,4,4,5,6,7,8,9,9,9,9,9,3,3,4,5,6,6],
    [5,6,6,9,5,9,4,4,4,5,6,7,9,9,9,9,9,3,3,4,5,5,6,7],
    [5,6,9,9,5,9,9,4,4,5,9,6,6,9,9,5,4,4,4,4,5,5,6,6],
    [4,4,9,3,0,5,9,5,5,9,9,9,9,5,6,6,5,5,5,5,5,4,3,4],
    [2,9,9,1,2,4,9,9,5,6,9,9,9,9,6,7,6,6,6,6,5,3,1,1],
    [2,1,9,9,9,5,9,5,5,6,6,9,9,9,5,6,6,6,6,6,5,3,1,1],
    [2,2,1,2,3,5,6,5,5,5,5,4,9,2,4,9,5,5,6,6,5,3,2,2],
    [4,4,3,3,4,5,5,4,4,4,4,3,2,2,9,9,9,4,4,5,5,4,4,4],
    [4,5,5,4,4,4,3,3,3,3,4,3,3,3,4,9,3,3,3,4,4,4,5,5],
    [4,5,5,4,3,2,2,1,2,3,4,5,5,5,5,4,3,2,2,2,3,3,0,5],
    [4,4,4,3,2,1,1,1,2,3,4,5,7,7,6,4,3,2,1,1,2,3,4,4]
]`}
</pre>

<h3>Submission Requirements</h3>

<ol>
  <li>
    Implement an efficient path-planning algorithm in
    <strong> Python or C++</strong>.
  </li>

  <li>
    Your solution should correctly account for:
    <ul>
      <li>Shortest path optimization.</li>
      <li>Battery constraints.</li>
      <li>Engine heat constraints.</li>
      <li>Recharge station usage.</li>
    </ul>
  </li>

  <li>
    Clearly explain the approach, assumptions, and algorithmic complexity of
    your solution.
  </li>

  <li>
    <strong>Partial solutions are welcome.</strong> Even if your implementation
    is incomplete, we encourage you to submit your approach.
  </li>
</ol>

<div
  style={{
    display: "flex",
    justifyContent: "center",
    marginTop: "30px",
  }}
>
  
</div>

                  <h3>
                    <strong>Submission </strong>
                  </h3>
                  <p>
                    {" "}
                    The solutions need to be submitted along with your details
                    via email to :{" "}
                    <a href="mailto:projectmanas.sna@gmail.com">
                      {" "}
                      projectmanas.sna@gmail.com{" "}
                    </a>{" "}
                  </p>

                  <p>
                    <b>NOTE: </b> The submissions over mail need to be
                    accompanied with the following details:
                    <ol>
                      <li>Full Name</li>
                      <li>Registration Number</li>
                      <li>Branch</li>
                      <li>Contact Number</li>
                    </ol>
                  </p>
                  <p>
                    {" "}
                    For any queries, please feel free to contact (Preferably
                    Whatsapp):{" "}
                  </p>
                  <div className="contact">
                    <p>
                      <b>Yash</b>
                      <br /> +91 7067750491
                      <br />
                    </p>
                    <p>
                      <b>Kavya</b>
                      <br /> +91 9080780274
                      <br />
                    </p>
                  </div>
                </div>
              </div>
            
          </AccordionDetails>
        </Accordion>
        </div>
        
    );
}